var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-range-picker',{attrs:{"value":_vm.value,"format":"DD/MM/YYYY","locale":_vm.ptBR,"ranges":_vm.ranges,"allowClear":_vm.allowClear,"placeholder":['Início', 'Fim']},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }